<template>
  <div class="c-tab-pictures">
    <CallCenterAEDpictures></CallCenterAEDpictures>
  </div>
</template>

<script>
import CallCenterAEDpictures from "@/components/AED/aed-pictures.vue";
export default {
  name: "c-tab-pictures",
  components: {
    CallCenterAEDpictures
  }
};
</script>
<style lang="scss">
.c-tab-pictures {
}
</style>
